import { render, staticRenderFns } from "./Scatt.vue?vue&type=template&id=0a931589&scoped=true&"
import script from "./Scatt.vue?vue&type=script&lang=js&"
export * from "./Scatt.vue?vue&type=script&lang=js&"
import style0 from "./Scatt.vue?vue&type=style&index=0&id=0a931589&prod&scoped=true&lang=css&"
import style1 from "./Scatt/styles/common.css?vue&type=style&index=1&id=0a931589&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a931589",
  null
  
)

export default component.exports